import React from 'react';
import './ChatTranscriptView.css'

const ChatTranscriptView = (props) => {
    const { recordings } = props;

    return (
        <div>
                <div className="container container-chat-transcript mx-2">
                    <textarea readOnly>
                        {recordings[0].transcript}
                    </textarea>
                </div>
        </div>
    );
}

export default ChatTranscriptView;